<template>
	<div>
		<BarraLateral v-if="exibirBarraLateral" />
		<v-app-bar app flat clipped-left outlined fixed color="background">
			<v-app-bar-title />
			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						v-bind="attrs"
						v-on="on"
						variant="text"
						:icon="icons.mdiThemeLightDark"
						@click="toggleThemeDarkMode"
						/>
				</template>
				<span>{{ vuetify.theme.current.value.dark ? 'Modo Claro' : 'Modo Escuro' }}</span>
			</v-tooltip>
		</v-app-bar>
	</div>
</template>

<script setup>
import BarraLateral from "@/components/navegacao/BarraLateral.vue";
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import vuetify from "@/plugins/vuetify.js";

const route = useRoute();

const icons = ref({
	mdiThemeLightDark: "mdi-theme-light-dark",
});

const rotaAutenticada = computed(() => {
	return !route.meta || !route.meta.isAuthenticated || route.meta.isAuthenticated === true;
});

const rotaErro = computed(() => {
	return route.meta && route.meta.isError || route.meta.isAuthenticated === true;
});

const exibirBarraLateral = computed(() => {
	return rotaAutenticada.value && !rotaErro.value;
});

function toggleThemeDarkMode(){
	localStorage.setItem("dark", (!vuetify.theme.current.value.dark).toString());
	vuetify.theme.toggle();
};
</script>
